import { urologyBlogs } from "./urology";
import { prostateBlogs } from "./prostate";
import { andrologyBlogs } from "./andrology";
import { infertilityBlogs } from "./infertility";
import { dermatologyBlogs } from "./dermatology";
import { aestheticBlogs } from "./aesthetic";
import { hairBlogs } from "./hair";
import { generalBlogs } from "./general";
import type { Blog } from "./types";

export { blogCategories, popularTopics } from "./categories";
export type { Blog, BlogSection, BlogFaq } from "./types";

export const blogs: Blog[] = [
  ...urologyBlogs,
  ...prostateBlogs,
  ...andrologyBlogs,
  ...infertilityBlogs,
  ...dermatologyBlogs,
  ...aestheticBlogs,
  ...hairBlogs,
  ...generalBlogs,
];

export const getBlog = (slug: string) => blogs.find((b) => b.slug === slug);

export const featuredBlogs = blogs.filter((b) => b.featured);

export const popularBlogs = blogs.filter((b) => b.popular);

/** Newest first, used for the "Latest Health Articles" section and ordering. */
export const latestBlogs = [...blogs].sort((a, b) => (a.date < b.date ? 1 : -1));

export const blogsByCategory = (cat: string) =>
  cat === "All" ? blogs : blogs.filter((b) => b.category === cat);

/** Search across title, excerpt, category, tags, keywords and author. */
export const searchBlogs = (cat: string, query: string) => {
  const base = blogsByCategory(cat);
  if (!query.trim()) return base;
  const q = query.trim().toLowerCase();
  return base.filter(
    (b) =>
      b.title.toLowerCase().includes(q) ||
      b.excerpt.toLowerCase().includes(q) ||
      b.category.toLowerCase().includes(q) ||
      b.author.toLowerCase().includes(q) ||
      b.tags.some((t) => t.toLowerCase().includes(q)) ||
      b.primaryKeyword.toLowerCase().includes(q)
  );
};

/** Resolve related articles for a post, filling with fallbacks from the catalogue. */
export const getRelatedArticles = (slug: string, count = 4): Blog[] => {
  const current = getBlog(slug);
  if (!current) return [];
  const seen = new Set<string>([slug]);
  const result: Blog[] = [];
  const push = (list: (string | undefined)[]) => {
    for (const item of list) {
      if (!item || result.length >= count) continue;
      const b = getBlog(item);
      if (b && !seen.has(b.slug)) {
        seen.add(b.slug);
        result.push(b);
      }
    }
  };
  push(current.relatedArticles);
  if (result.length < count) {
    for (const b of latestBlogs) {
      if (result.length >= count) break;
      if (!seen.has(b.slug)) {
        seen.add(b.slug);
        result.push(b);
      }
    }
  }
  return result.slice(0, count);
};